import { CardContent as MuiCardContent, CardHeader, Card as MuiCard, styled, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import Grid from '@mui/material/Grid2';


interface CardProps {
    title?: string;
    startTitleIcon?: ReactNode;
    withHeadBorder?: boolean;
    action?: ReactNode;
    children: ReactNode;
    sxContent?: SxProps<Theme>;
    sxHeader?: SxProps<Theme>;
    sxCard?: SxProps<Theme>;
};

const StyledCardHeader = styled(CardHeader)<{ withheadborder?: boolean }>(({ withheadborder }) => ({
    ...(withheadborder ? { borderBottom: '1px solid #E1E3EB' } : {}),
    width: '100%'
}));

const IconGrid = styled(Grid)(({ theme }) => ({
    '> *': {
        display: 'inline',
        verticalAlign: 'middle',
        color: theme.palette.text.secondary,
        marginRight: '9px',
        fontSize: '18px',
        marginBottom: '3px'
    }
}));

export default function Card({ children, title, startTitleIcon, action, withHeadBorder, sxContent, sxHeader, sxCard, ...props }: CardProps) {
    return (
        <MuiCard sx={{ height: '100%', ...sxCard }} {...props}>
            { title && (
                <StyledCardHeader
                    title={
                    <Grid container justifyContent="space-between">
                        <Grid container size="auto" alignItems="center">
                            <IconGrid>
                              {startTitleIcon}
                            </IconGrid>
                            <Grid>
                              {title}
                            </Grid>
                        </Grid>
                        <Grid>
                           {action}
                        </Grid>
                    </Grid>}
                    withheadborder={withHeadBorder}
                    sx={{...(sxHeader ? sxHeader : {})}}
                />)
            }
            <MuiCardContent sx={{...(sxContent ? sxContent : {})}}>
              {children}
            </MuiCardContent>
        </MuiCard>
    );
}